import { render, staticRenderFns } from "./buscador.vue?vue&type=template&id=67280f54&scoped=true&"
import script from "./buscador.vue?vue&type=script&lang=js&"
export * from "./buscador.vue?vue&type=script&lang=js&"
import style0 from "./buscador.vue?vue&type=style&index=0&id=67280f54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67280f54",
  null
  
)

export default component.exports